const primitives = {
  borderWidths: {
    0: "0",
    1: "1px",
    2: "2px",
    3: "3px",
    4: "4px",
    5: "5px",
    6: "6px",
    8: "8px",
    10: "10px"
  }
};
const tokens = {
  borderWidths: {
    none: primitives.borderWidths[0],
    small: primitives.borderWidths[1],
    medium: primitives.borderWidths[2],
    large: primitives.borderWidths[3],
    xLarge: primitives.borderWidths[5]
  }
};

export { tokens };
